// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAnnotationsAnnotationOff_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.44971 0H5.44971L5.15912 1.16233C4.44774 1.46879 3.94971 2.17623 3.94971 3 3.94971 3.50722 4.13853 3.97035 4.44971 4.32291V6.08545L5.44971 5.08545V4.93699C5.48966 4.94727 5.53009 4.95635 5.57097 4.96419L7.9139 2.62126C7.78786 1.96373 7.33985 1.42061 6.74029 1.16233L6.44971 0ZM5.94971 2C5.39742 2 4.94971 2.44772 4.94971 3 4.94971 3.55228 5.39742 4 5.94971 4 6.50199 4 6.94971 3.55228 6.94971 3 6.94971 2.44772 6.50199 2 5.94971 2ZM4.44971 8.91372 2.41414 10.9493 1.70703 10.2422 10.1923 1.75691 10.8994 2.46401 7.44971 5.91372V7H8.44971V8H7.44971V10L6.44971 12V8H5.44971V12L4.44971 10V8.91372ZM6.44971 6.91372V7H6.36343L6.44971 6.91372Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.5 8.10504 15.7781 2.82692 14.3639 1.4127 1.63599 14.1406 3.0502 15.5548 5.54202 13.063 7.5 16V11.105L7.60504 11H8.5V16L10.5 13V11H12V9H10.5V8.10504ZM8.96319 1.15796C9.62215 1.38122 10.1784 1.82722 10.5422 2.40633L8.99876 3.94973C8.97257 3.4208 8.53543 3 8 3 7.44772 3 7 3.44772 7 4 7 4.53543 7.4208 4.97257 7.94973 4.99876L5.5 7.44849V5.6589C5.18408 5.18374 5 4.61337 5 4 5 2.68007 5.85243 1.55923 7.03681 1.15796L7.5 0H8.5L8.96319 1.15796Z" class="svg-bg"/>
</svg>
`;
/**
 * IconAnnotationsAnnotationOff is a generated icon component.
 */
let IconAnnotationsAnnotationOff = IconAnnotationsAnnotationOff_1 = class IconAnnotationsAnnotationOff extends IconBaseElement {
    render() {
        return html `${IconAnnotationsAnnotationOff_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAnnotationsAnnotationOff.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconAnnotationsAnnotationOff = IconAnnotationsAnnotationOff_1 = __decorate([
    customElement('zui-icon-annotations-annotation-off')
], IconAnnotationsAnnotationOff);
export { IconAnnotationsAnnotationOff };
